module.exports = __webpack_public_path__ + "static/img/7.79e2c2ac.png";